import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { QuotationModel } from 'src/app/models/preliminaries/quotation.model';
import { QuotationService } from 'src/app/services/preliminaries/quotation.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-reject-quotation',
  templateUrl: './reject-quotation.component.html',
  styleUrls: ['./reject-quotation.component.scss'],
  standalone: false
})
export class RejectQuotationComponent implements OnInit {

  listRejectConcepts: any[] = [];
  quotationContract: QuotationModel = new QuotationModel();
  public formRejectQuotation: FormGroup = new FormGroup({});
  subscription: Subscription;

  constructor(private quotationService: QuotationService,
    private formBuilder: FormBuilder,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
  }

  ngOnInit() {
    this.getAllLists();

    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.subscription = input$?.subscribe((inputs: any) => {
      this.quotationContract = inputs.quotationModel;
      this.validateForm(this.quotationContract);
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async getAllLists() {
    try {
      const [rejectConcept] = await Promise.all([
        firstValueFrom(this.quotationService.getAllRejectConceptsForSelect())
      ]);

      this.listRejectConcepts = rejectConcept;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas por sucursal.', error);
      return false;
    }
  }

  async getRejectConcept(conceptId: number | null) {
    const previousConceptId = this.quotationContract.conceptIdConceptRejection;
    if (previousConceptId === conceptId) {
      return;
    }

    if (conceptId) {
      this.formRejectQuotation.controls["conceptIdConceptRejection"].patchValue(conceptId);
    } else {
      this.formRejectQuotation.controls["conceptIdConceptRejection"].patchValue(null);
    }
  }

  async rejectQuotation() {
    if (this.formRejectQuotation.valid) {
      const modelQuotation = this.formRejectQuotation.value as QuotationModel;
      this.quotationContract.conceptIdConceptRejection = modelQuotation.conceptIdConceptRejection;
      this.quotationContract.observationRejection = modelQuotation.observationRejection;
      try {
        const response = await firstValueFrom(this.quotationService.rejectQuotation(this.quotationContract));
        if (response) {
          const output$ = this.config.data?.output$;
          output$?.next({ type: 'updateQuotation', payload: response });
          this.toastHandlerService.showToast('success', 'La cotización se rechazo, exitosamente.', '');
        }
        this.validateForm(response);
        if (this.ref) this.ref.close();
      } catch (error) {
        console.error('Error catch:', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      conceptIdConceptRejection: {
        required: 'El campo concepto es obligatorio.'
      },
      observationRejection: {
        maxlength: 'El campo observación rechazo permite máximo 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formRejectQuotation.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm(quotation: QuotationModel) {
    this.formRejectQuotation = this.formBuilder.group({
      conceptIdConceptRejection: [quotation.conceptIdConceptRejection, [Validators.required, Validators.min(1)]],
      observationRejection: [quotation.observationRejection, [Validators.required, Validators.maxLength(250)]]
    });
  }
}